export default __webpack_public_path__ + "static/media/csulb_logo.2bf01732.png";